export default {
  NO_WORK_PLANNED: 'NO_WORK_PLANNED',
  WORK_PLANNED: 'WORK_PLANNED',
}
